import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select } from 'components';
import { TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import { ExcludedPlaceService } from 'services';
import CreatePlace from './create-place';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class ExcludedPlaces extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'Latitud',
			'Longitud',
			'Acciones'
		],
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Lugares Excluidos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ExcludedPlaceService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.excluded_places.rows,
			last_page: res.excluded_places.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el lugar?',async () => {
			await ExcludedPlaceService.admin.delete({
				place_id: item.id
			});
			this.load(true);
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="admin-excluded-places">
				<BackComponent />

				<Modal
		          className="modal-create-place"
		          visible={ visible }
		          title=""
		          centered
		          onClose={ () => this.onClose() }
		        >
		        	<CreatePlace
		        		title={ `${ this.state.item ? 'Editar' : 'Nuevo' } Lugar` }
		        		onClose={ () => this.onClose() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-4">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4 text-right">
						{
							checkPermission(Constants.MODULES.EXCLUDED_PLACES,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td>{ i.latitude }</td>
								<td>{ i.longitude }</td>
								<td>
									{
										checkPermission(Constants.MODULES.EXCLUDED_PLACES,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.EXCLUDED_PLACES,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(ExcludedPlaces);